<template>
  <div id="userLoginPage">
    <h2 style="margin-bottom: 16px">设置评分</h2>
    <a-form
      :model="form"
      auto-label-width
      style="width: 480px"
      label-align="left"
      @submit="handleSubmit"
    >
      <a-form-item label="应用 id">
        {{ appId }}
      </a-form-item>
      <a-form-item v-if="updateId" label="修改评分 id">
        {{ updateId }}
      </a-form-item>
      <a-form-item field="resultName" label="结果名称">
        <a-input v-model="form.resultName" placeholder="请输入应用名称" />
      </a-form-item>
      <a-form-item field="resultDesc" label="结果描述">
        <a-input v-model="form.resultDesc" placeholder="请输入应用描述" />
      </a-form-item>
      <a-form-item field="resultPicture" label="结果图标">
        <PictureUploader
          biz="app_icon"
          :value="form.resultPicture"
          :on-change="(url:string) => (form.resultPicture = url)"
        ></PictureUploader>
      </a-form-item>
      <a-form-item field="resultProp" label="结果集">
        <a-input-tag
          v-model="form.resultProp"
          :style="{ width: '320px' }"
          placeholder="请输出结果集，按回车确认"
          allow-clear
        >
        </a-input-tag>
      </a-form-item>
      <a-form-item field="resultScoreRange" label="结果得分范围">
        <a-input-number
          v-model="form.resultScoreRange"
          placeholder="请输入结果评分范围"
        ></a-input-number>
      </a-form-item>
      <a-form-item>
        <a-button html-type="submit" style="width: 120px" type="primary"
          >提交</a-button
        >
      </a-form-item>
    </a-form>
    <h2 style="margin-bottom: 16px">评分管理</h2>
    <ScoringResultTable
      :appId="appId"
      :do-update="doUpdate"
      ref="tableRef"
    ></ScoringResultTable>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, defineProps, ref, watchEffect } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import { Message } from "@arco-design/web-vue";
import { useRouter } from "vue-router";
import API from "@/api";
import {
  addScoringResultUsingPost,
  editScoringResultUsingPost,
} from "@/api/scoringResultController";
import PictureUploader from "@/components/PictureUploader.vue";
import ScoringResultTable from "@/views/add/component/ScoringResultTable.vue";

const router = useRouter();

interface Props {
  appId: string;
}

const props = withDefaults(defineProps<Props>(), {
  appId: () => {
    return "";
  },
});

const form = ref({
  resultDesc: "",
  resultName: "",
  resultPicture: "",
} as API.ScoringResultAddRequest);

const tableRef = ref();

const updateId = ref();
const doUpdate = (scoringResult: API.ScoringResultVO) => {
  updateId.value = scoringResult.id;
  form.value = scoringResult;
};

/*
 * 提交
 * */
const handleSubmit = async () => {
  if (!props.appId) {
    return;
  }
  let res: any;
  // 如果是修改
  if (updateId.value) {
    res = await editScoringResultUsingPost({
      id: updateId.value as any,
      ...form.value,
    });
  } else {
    res = await addScoringResultUsingPost({
      appId: props.appId as any,
      ...form.value,
    });
  }

  if (res.data.code === 0) {
    Message.success("操作成功");
  } else {
    Message.error("创建失败，" + res.data.message);
  }

  if (tableRef.value) {
    tableRef.value?.loadData();
    updateId.value = undefined;
    form.value = {
      resultDesc: "",
      resultName: "",
      resultPicture: "",
    };
  }
};
</script>

<style scoped></style>
